import useSWR from 'swr';

const fetcher = (url: string) => fetch(url).then((res) => res.json());

type LoggedInState = {
    isLoggedIn: boolean;
    // biome-ignore lint/suspicious/noExplicitAny: error is typed as any from useSWR
    error: any;
};

type LoggedInApi = {
    loggedIn: boolean;
};

export const useLoggedInState = (): LoggedInState => {
    // This endpoint is implemented in the frontpage-web app
    const { data, error } = useSWR<LoggedInApi>('/reise/api/loggedin/', fetcher);

    return {
        isLoggedIn: data?.loggedIn ?? false,
        // Now error is only needed for the test
        error,
    };
};
